// outros-resources-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A cardinalidade do envio será definida no momento do envio": "La cardinalidad del envío será definida en el momento del envío",
    "A definir": "A definir",
    "Abastecimento unificado": "Carga de combustible unificada",
    "Abastecimentos Por Hora": "Cargas Por Hora",
    "Abastecimentos por Combustível": "Cargas por Combustible",
    "Adicionar combustível": "Agregar combustible",
    "Ajustar Descontos Fixos": "Ajustar Descuentos Fijos",
    "Alertas de expiração": "Alertas de expiración",
    "App em foco (%)": "App en foco (%)",
    "App em foco (ms)": "App en foco (ms)",
    "Atualizar": "Actualizar",
    "Avaliação não encontrada": "Evaluación no encontrada",
    "Bluetooth conectado": "Bluetooth conectado",
    "Cadastrar carregador elétrico": "Registrar cargador eléctrico",
    "Cadastrar método de pagamento externo": "Registrar método de pago externo",
    "Cadastrar nova regra de sorteio": "Registrar nueva regla de sorteo",
    "Cadastrar novo usuário": "Registrar nuevo usuario",
    "Cancelar Envio": "Cancelar Envío",
    "Cardinalidade": "Cardinalidad",
    "Categoria de Clientes": "Categoría de Clientes",
    "Clicado em": "Cliqueado en",
    "Clientes Indicados": "Clientes Referidos",
    "Clientes em Recuperação": "Clientes en Recuperación",
    "Clique no botão abaixo para acessar a página de login": "Haga clic en el botón de abajo para acceder a la página de inicio de sesión",
    "Combustível pai": "Combustible padre",
    "Considerado tanque cheio?": "¿Considerado tanque lleno?",
    "Corpo da Mensagem": "Cuerpo del Mensaje",
    "Corpo da mensagem": "Cuerpo del mensaje",
    "Criar Regra de Recuperação": "Crear Regla de Recuperación",
    "Criar desconto agendado": "Crear descuento programado",
    "Criar regra para grupo de clientes": "Crear regla para grupo de clientes",
    "Cupom expira em": "Cupón expira en",
    "Custo médio por recuperação": "Costo promedio por recuperación",
    "Código ANP": "Código ANP",
    "Código do cliente": "Código del cliente",
    "Dados arquivados": "Datos archivados",
    "Data de Início": "Fecha de Inicio",
    "Data de recebimento": "Fecha de recepción",
    "Data do recebimento": "Fecha de recepción",
    "Data inclusão": "Fecha de inclusión",
    "Desconto vinculado": "Descuento vinculado",
    "Descontos Agendados": "Descuentos Programados",
    "Descontos do tipo Recuperação.": "Descuentos del tipo Recuperación.",
    "Descontos por combustível": "Descuentos por combustible",
    "Descontos salvos": "Descuentos guardados",
    "Detalhes do abastecimento": "Detalles de la carga de combustible",
    "Dias Inatividade": "Días Inactividad",
    "Dias de inatividade": "Días de inactividad",
    "Dias entre níveis": "Días entre niveles",
    "Dias entre níveis para escalar": "Días entre niveles para escalar",
    "Dias p/ Escalar": "Días p/ Escalar",
    "Duração de um abastecimento": "Duración de una carga de combustible",
    "Editar Abastecimneto": "Editar Carga de Combustible",
    "Editar combustível filho": "Editar combustible hijo",
    "Editar desconto agendado": "Editar descuento programado",
    "Editar imagem da Home": "Editar imagen de Inicio",
    "Editar método de pagamento externo": "Editar método de pago externo",
    "Editar regra de sorteio": "Editar regla de sorteo",
    "Editar regra para grupo de clientes": "Editar regla para grupo de clientes",
    "Editar usuário": "Editar usuario",
    "Em recuperação": "En recuperación",
    "Encher tanque por combustíveis": "Llenar tanque por combustible",
    "Encher tanque vs Não encher tanque": "Llenar tanque vs No llenar tanque",
    "Entre em contato com o administrador e solicite um novo convite de cadastro.": "Póngase en contacto con el administrador y solicite una nueva invitación de registro.",
    "Enviados": "Enviados",
    "Enviar push notification": "Enviar notificación push",
    "Envio": "Envío",
    "Envio cancelado com sucesso.": "Envío cancelado con éxito.",
    "Erro ao cancelar envio.": "Error al cancelar envío.",
    "Erro ao carregar abastecimentos por hora.": "Error al cargar cargas por hora.",
    "Erro ao carregar dados de comportamento de abastecimento": "Error al cargar datos de comportamiento de carga de combustible",
    "Erro ao carregar dados de pontos": "Error al cargar datos de puntos",
    "Erro ao carregar gráfico de combustíveis": "Error al cargar gráfico de combustibles",
    "Erro ao carregar o Nuvem de Palavras": "Error al cargar la Nube de Palabras",
    "Erro ao carregar o ranking de frentistas": "Error al cargar el ranking de playeros",
    "Erro ao enviar": "Error al enviar",
    "Erro ao listar descontos": "Error al listar descuentos",
    "Erro ao salvar descontos": "Error al guardar descuentos",
    "Escalados": "Escalados",
    "Escalar automaticamente": "Escalar automáticamente",
    "Escalação": "Escalación",
    "Expirados": "Expirados",
    "Expiração (horas)": "Expiración (horas)",
    "Fator Pontos/Litro": "Factor Puntos/Litro",
    "Gasto": "Gasto",
    "Gasto acumulado": "Gasto acumulado",
    "Gasto máximo total": "Gasto máximo total",
    "Gerar qrcode": "Generar código QR",
    "Gráfico de Novos Clientes": "Gráfico de Nuevos Clientes",
    "Histórico de Execuções": "Historial de Ejecuciones",
    "ID da Reserva": "ID de la Reserva",
    "ID do dispositivo": "ID del dispositivo",
    "Imagem atual": "Imagen actual",
    "Informações técnicas": "Información técnica",
    "Ir para o login": "Ir al inicio de sesión",
    "Lida em": "Leída en",
    "Limite atingido": "Límite alcanzado",
    "Mensagem push": "Mensaje push",
    "Modo de escalação": "Modo de escalación",
    "Máximo de clientes por ciclo": "Máximo de clientes por ciclo",
    "Métodos de pagamento": "Métodos de pago",
    "Métodos de pagamentos externos": "Métodos de pagos externos",
    "Métricas": "Métricas",
    "Nenhum canal selecionado": "Ningún canal seleccionado",
    "Nenhum desconto vinculado": "Ningún descuento vinculado",
    "Nova imagem da Home": "Nueva imagen de Inicio",
    "Nuvem de Palavras": "Nube de Palabras",
    "Níveis de Desconto": "Niveles de Descuento",
    "Nível": "Nivel",
    "Número do bico": "Número del pico",
    "O código é o que aparece no fim da URL do QR do carregador. Em": "El código es lo que aparece al final de la URL del QR del cargador. En",
    "Ordem": "Orden",
    "Ordem de exibição": "Orden de visualización",
    "Os dados detalhados de usuários para este envio foram arquivados. As estatísticas resumidas acima refletem o estado final do envio.": "Los datos detallados de usuarios para este envío fueron archivados. Las estadísticas resumidas arriba reflejan el estado final del envío.",
    "Pagamentos externos": "Pagos externos",
    "Parceiro / Posto": "Socio / Estación",
    "Parceiro ou Posto": "Socio o Estación",
    "Período": "Período",
    "Placeholders: {nome}, {desconto}, {nivel}, {combustivel}": "Placeholders: {nome}, {desconto}, {nivel}, {combustivel}",
    "Pontos Adicionados Manualmente": "Puntos Agregados Manualmente",
    "Pontos Gerados X Pontos Resgatados": "Puntos Generados X Puntos Canjeados",
    "PontuaX Admin": "PontuaX Admin",
    "PontuaX — Todos os direitos reservados": "PontuaX — Todos los derechos reservados",
    "Postos vinculados": "Estaciones vinculadas",
    "Preset Limite": "Preset Límite",
    "Preset Valor": "Preset Valor",
    "Preço por litro original": "Precio por litro original",
    "Preço por litro real": "Precio por litro real",
    "Processados": "Procesados",
    "Qrcode de confirmação": "Código QR de confirmación",
    "R$": "R$",
    "Ranking Pontos Adicionados": "Ranking Puntos Agregados",
    "Recuperado em": "Recuperado en",
    "Recuperados": "Recuperados",
    "Regra de Recuperação": "Regla de Recuperación",
    "Regras de Recuperação": "Reglas de Recuperación",
    "Regras para grupos de clientes": "Reglas para grupos de clientes",
    "Se o campo for deixado como zero, o valor não será exibido.": "Si el campo se deja en cero, el valor no será mostrado.",
    "Sem Etiqueta": "Sin Etiqueta",
    "Sem Grupo": "Sin Grupo",
    "Sem dados ainda": "Sin datos todavía",
    "Sem dados para exibir": "Sin datos para mostrar",
    "Sem postos vinculados": "Sin estaciones vinculadas",
    "Sigla": "Sigla",
    "Sobrepor desconto de grupo": "Sobrescribir descuento de grupo",
    "Status de clique": "Estado de clic",
    "Status de leitura": "Estado de lectura",
    "Taxa de sucesso": "Tasa de éxito",
    "Tipo do combustível (ConectTec)": "Tipo de combustible (ConectTec)",
    "Tipos externos de pagamentos": "Tipos externos de pagos",
    "Todos os clientes": "Todos los clientes",
    "Top Frentistas": "Top Playeros",
    "Trocar imagem (opcional)": "Cambiar imagen (opcional)",
    "Título (opcional, usado como alt)": "Título (opcional, usado como alt)",
    "Título do push": "Título del push",
    "Um abastecimento a cada": "Una carga de combustible cada",
    "Uma representação visual da frequência que as palavras aparecem nos comentários em avaliações dos abastecimentos.": "Una representación visual de la frecuencia con que las palabras aparecen en los comentarios de las evaluaciones de las cargas de combustible.",
    "Usuário de local": "Usuario de local",
    "Usuários": "Usuarios",
    "Usuários Deletados de Parceiros": "Usuarios Eliminados de Socios",
    "Valor do desconto concedido": "Valor del descuento otorgado",
    "Venda de Combustíveis": "Venta de Combustibles",
    "Versão do dispositivo": "Versión del dispositivo",
    "abastecimentos que o AutoSystem do posto registrou como uma venda só. Quantidade, valor e encerrante são os do conjunto; os pontos de todos eles estão neste registro.": "cargas de combustible que el AutoSystem de la estación registró como una sola venta. La cantidad, el valor y el totalizador son los del conjunto; los puntos de todas ellas están en este registro.",
    "cliente(s) em recuperação": "cliente(s) en recuperación",
    "customized table": "customized table",
    "— reúne": "— reúne",
};

export default catalogo;
